import { sendRequest } from './api';
const BASE_URL = 'export';
export const createExport = (data) => {
    return sendRequest(BASE_URL, 'POST', data);;
};
